import "./ArticlesCardStyles.css";

import ArticlesCard from "./ArticlesCard";
import ArticlesCardData from "./ArticlesCardData";

import React from 'react'

const Articles = () => {
  return (
    <div className="articles-container">
        <h1 className="articles-heading">Artículos recientes</h1>
        <div className="article-container">
            {ArticlesCardData.map((value, index) =>{
                    return(
                        <ArticlesCard
                        key={index}
                        imgsrc={value.imgsrc}
                        title={value.title}
                        view={value.view}
                        >

                        </ArticlesCard>
                    )
                })}
        </div>
    </div>
  )
}

export default Articles